<template>
  <view-toolbox
    back-title="Edit Grid"
    title="Source"
  >
    <div>
      <Source />
    </div>
  </view-toolbox>
</template>
<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import Source from '@/components/views/shared/Source';

export default {
  components: {
    ViewToolbox,
    Source,
  },
};
</script>
